module.exports = __webpack_public_path__ + "img/ps-56.e1b2c314.jpg";